module.exports = __webpack_public_path__ + "img/account-symbol.907c1058.svg";